module.exports = __webpack_public_path__ + "static/docker-2e019a3e3de35c465f636710d4b77f5c.svg";